export default function Hero() {
  return (
    <section className="hero">
      <div className="eyebrow" data-reveal>Customs · Ocean · Air · Road</div>
      <h1 id="heroTitle">Global cargo,<br /><span className="grad">zero friction.</span></h1>
      <p data-reveal>From clearance to delivery — Folk Cargo Solutions moves your business through customs, ocean, air and road freight, without the red tape.</p>
      <div className="hero-actions" data-reveal>
        <a href="#contact" className="btn btn-primary">Get a Quote →</a>
        <a href="#services" className="btn btn-ghost">Explore Services</a>
      </div>
      <div className="scroll-cue"><span>Scroll</span><div className="line" /></div>
    </section>
  );
}
